import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { TimeGridSVG } from 'images/timegrid.svg';

const TimeGridIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <TimeGridSVG/>
    </div>
  );
};

export { TimeGridIcon };
